package br.com.texeratx.boardgametimeapp.core.spotify.di

import br.com.texeratx.boardgametimeapp.core.spotify.storage.SpotifyStorage
import br.com.texeratx.boardgametimeapp.core.spotify.storage.SpotifyStorageJs
import org.koin.dsl.module

val spotifyJsModule = module {
    single<SpotifyStorage> { SpotifyStorageJs() }
}
